import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ParksLayout } from "../Layout/ParksLayout";
import ParkCatalog from "../Pages/ParkCatalog/ParkCatalog";
import ParkDetail from "../Pages/ParkDetail/ParkDetail";
import SistemaCompra from "../Pages/SistemaCompra/SistemaCompra";
import LandingPage from "../Pages/LandingPageParques";
import Factura from "../Pages/Factura/Factura";
import useUser from "../Context/hook/useUser";
import UseTermsPage from "../Pages/UseTermsPage/UseTermsPage";
import PrivacyPoliciesPage from "../Pages/PrivacyPoliciesPage/PrivacyPoliciesPage";
import { Provider } from "react-redux";
import SistemaCompraGuest from "../Pages/SistemaCompraGuest/SistemaCompraGuest";
export const ParksRouter = () => {
  const { getUser, isAuth } = useUser();

  const PrivateRoute = ({ children, redirectTo, path }) => {
    let verify = getUser()?.emailVerify;
    return !isAuth() ? (
      <Navigate to={"/login"} state={{ pre: path }} />
    ) : isAuth() && !verify ? (
      <Navigate to={{ pathname: "/verify" }} />
    ) : (
      children
    );
  };

  return (
    <Routes>
      <Route path="/detail/:id" element={<ParkDetail />}></Route>
      <Route index element={<LandingPage />}></Route>
      <Route path="" element={<ParksLayout />}>
        <Route path="terminos" element={<UseTermsPage />} />
        <Route path="politicas" element={<PrivacyPoliciesPage />} />

        <Route
          path="detail/guest/payment/:id"
          element={<SistemaCompraGuest />}
        />

        <Route
          path="detail/payment/:id"
          element={
            <PrivateRoute>
              <SistemaCompra />
            </PrivateRoute>
          }
        />
        <Route path="paycheck" element={<Factura />} />
        <Route path="catalog" element={<ParkCatalog />} />
      </Route>
    </Routes>
  );
};
